import { instance, endpoint, isMock, generator } from 'api'
import { mocker } from 'api/hress5u/mocker'

export default {
  getLabels () {
    if (isMock) return generator(mocker.labels())
    return instance().get(endpoint + '/hress5u/labels')
  },
  getIndex (searchParams) {
    if (isMock) return generator(mocker.index())
    let sendParams = {}
    if (typeof searchParams !== 'undefined') {
      sendParams = {
        p_dtest: (typeof searchParams.dteapprst !== 'undefined' ? searchParams.dteapprst : ''),
        p_dteen: (typeof searchParams.dteappren !== 'undefined' ? searchParams.dteappren : ''),
        p_staappr: (typeof searchParams.staappr !== 'undefined' ? searchParams.staappr : 'P'),
        p_codempid: (typeof searchParams.codempid !== 'undefined' ? searchParams.codempid : '')
      }
    }
    return instance().get(endpoint + '/hress5u/index', { params: sendParams })
  },
  getDetail (searchParams) {
    if (isMock) return generator(mocker.detail())
    const params = searchParams.p_codempid + '/' + searchParams.p_dtereq.replace(/\//g, '') + '/' + searchParams.p_numseq
    return instance().get(endpoint + '/hress5u/detail/' + params)
  },
  postSendApprove (sendParams) {
    if (isMock) return generator(mocker.sendApprove())
    return instance().post(endpoint + '/hress5u/sendApprove', sendParams)
  },
  getPopup1DetailTab2 (searchParams) {
    let sendParams = {}
    sendParams = {
      p_numreqst: searchParams.p_numreqst
    }
    if (isMock) return generator(mocker.popup1DetailTab2())
    // const params = searchParams.p_numreqst + '/' + searchParams.p_codpos + '/' + searchParams.p_codjob
    const params = searchParams.p_codpos + '/' + searchParams.p_codjob
    return instance().get(endpoint + '/hress5u/detailTab2Popup1/' + params, { params: sendParams })
  },
  getPopup2DetailTab2 (searchParams) {
    let sendParams = {}
    sendParams = {
      p_numreqst: searchParams.p_numreqst
    }
    if (isMock) return generator(mocker.popup2DetailTab2())
    // const params = searchParams.p_numreqst + '/' + searchParams.p_codpos + '/' + searchParams.p_codjob
    const params = searchParams.p_codpos + '/' + searchParams.p_codjob
    return instance().get(endpoint + '/hress5u/detailTab2Popup2/' + params, { params: sendParams })
  }
}



// WEBPACK FOOTER //
// ./src/api/hress5u/index.js